import React, { Component } from 'react';

import { Form } from 'react-bootstrap';

import Select from 'react-select';

import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

class CommonSuggestSelect extends Component{

    render = () => {

        let props = this.props;

        let { type, id, label, value, validator, error} = props?.input;

        let { element, option, instanceOptionName= null, callback , disabled = false, hr = false, floatingLabel = true, size="md" } = props;

        let { source, section, item, data } = option

        let lists = [];

        if( source === 'options' ){
            lists = options[section][item];
        }else if( source === 'db' ){
            lists = {defaulted: true, options: option.data};
        }

        lists = {
            ...lists,
            options: lists?.options?.filter(option => option.id !== '') || []
        };
        
        return (
            <>
                {element === 'Inputs' && label !== '' && floatingLabel === true && (
                    <div className="mb-0">
                        <Form.Label className={size === 'sm' ? 'label-size-sm' : ''}>
                            {label}{' '}
                            {validator.required && (
                                <i
                                className="fa-classic fa-light fa-asterisk fa-fw"
                                style={{
                                    fontSize: '0.5rem',
                                    verticalAlign: 'text-top'
                                }}
                                />
                            )}
                        </Form.Label>
                    </div>
                )}
                <Select
                    inputId={id}
                    name={`${element}_${id}`}
                    isDisabled={disabled}
                    placeholder="กรุณาระบุ"
                    isClearable
                    isSearchable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    value={
                        lists.options
                            .map(option => ({
                                value: source === 'options' ? option.value : option.id,
                                label:
                                    source === 'options'
                                        ? option.label
                                        : (option[instanceOptionName] ?? option.name)
                            }))
                            .find(opt => opt.value === value) || null
                    }
                    options={lists.options.map(option => ({
                        value: source === 'options' ? option.value : option.id,
                        label:
                            source === 'options'
                                ? option.label
                                : (option[instanceOptionName] ?? option.name)
                    }))}
                    onChange={(selected) =>
                        callback(
                            {
                                target: {
                                    id: id,
                                    name: `${element}_${id}`,
                                    value: selected?.value || ''
                                }
                            },
                            element
                        )
                    }
                />
                
                {(element === 'Inputs' && error?.status) && (
                    <Form.Control.Feedback type="invalid" className="mt-2 ms-2" style={{fontSize: '0.75rem'}}>
                        <i className="fa-classic fa-light fa-circle-exclamation fa-fw me-1" />
                        {error?.msg}
                    </Form.Control.Feedback>
                )}

                {hr && (<hr className="hr-custom" />)}
            </>
        )
    }
}

export default CommonSuggestSelect;